import { useState, useEffect } from "react";

export const MapLocation = ({ lat = null, lon = null }) => {
  const [loc, setLoc] = useState({ lat: lat, lon: lon });
  const getLoc = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          const lat = position.coords.latitude;
          const lon = position.coords.longitude;
          setLoc({ lat: lat, lon: lon });
        },
        function (error) {
          console.error("Error obteniendo la geolocalización: ", error);
          setLoc({ lat: null, lon: null });
        }
      );
    } else {
      console.log("Geolocalización no está disponible en este navegador.");
      setLoc({ lat: null, lon: null });
    }
  };

  useEffect(() => {
    getLoc();
  }, []);

  //Los dos primeros modificadores afectan al zoom y los dos últimos a la posición
  const bbox = `${loc.lon - 0.005},${loc.lat - 0.005},${loc.lon + 0.004},${loc.lat - 0.0008}`;
  const marker = `${loc.lat},${loc.lon}`;
  const mapUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${marker}`;

  return <iframe title="mapLocation" width="100%" height="100%" src={mapUrl}></iframe>;
};
